import IPaymentDetails from "./PaymentDetails.interface";
import IBaseStepModel from "./interfaces/BaseStepModel.interface";

export interface IRegiftPaymentStep extends IBaseStepModel {
    paymentDetails: IPaymentDetails;
    termsAccepted: boolean;
}

export class RegiftPaymentStepModel implements IRegiftPaymentStep, IBaseStepModel {
    paymentDetails: IPaymentDetails;

    termsAccepted: boolean;
    isDirty: boolean;

    constructor(
    ) {
        this.termsAccepted = false;
        this.paymentDetails = {
            currency: "euro",
            cardAmount: 0,
            totalAmount: 0,
            totalFees: 0
        } as IPaymentDetails;
    }

    static validateModel(model: IRegiftPaymentStep) {

        if (!model) return false;

        return model.termsAccepted;
    }
}